"use client";
import { Heading } from "components/layout/Heading";
import { Container } from "components/layout/Container";
import styles from "./SectionPricesAddFeatures.module.scss";
import { useEffect } from "react";
import { ExtraFeatureCard } from "./ExtraFeatureCard";
import { baseUrl, orderFormUrl } from "@/const";
import {
  useOrderForm,
  useOrderFormInitialSetup,
  getExtraFeatureName,
  getExtraFeaturesFromEntity,
} from "@/lib/priceCalculator";

export type SectionPricesAddFeaturesProps = {
  heading: string;
  subheading: string;
};

export const SectionPricesAddFeatures = ({ heading, subheading }: SectionPricesAddFeaturesProps) => {
  const { config, formValues, setFormValues, defaults, dispatch } = useOrderFormInitialSetup(
    baseUrl,
    orderFormUrl
  );

  const { submit } = useOrderForm(config, formValues, defaults, baseUrl);

  useEffect(() => {
    if (formValues.selectedFeatures?.length) submit();
  }, [formValues.selectedFeatures, submit]);

  return (
    <section className={styles.section}>
      <Container>
        <Heading
          className={styles.heading}
          title={heading}
          subheading={subheading}
          image="/img/icons/60/sparkles.png"
        />
        <div className={styles.itemsWrap}>
          {config &&
            getExtraFeaturesFromEntity(config).map(
              ({ idExtraFeatureType, flatSurcharge, percentageSurcharge, customerDescription }) => {
                return (
                  <ExtraFeatureCard
                    key={idExtraFeatureType}
                    id={idExtraFeatureType}
                    name={getExtraFeatureName(idExtraFeatureType)}
                    customerDescription={customerDescription}
                    flatSurcharge={flatSurcharge || 0}
                    percentageSurcharge={percentageSurcharge || 0}
                    onClick={() => {
                      setFormValues({
                        ...formValues,
                        selectedFeatures: [idExtraFeatureType],
                      });
                    }}
                  />
                );
              }
            )}
        </div>
      </Container>
    </section>
  );
};
